var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDecline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99922 1.2002C4.24562 1.2002 1.19922 4.2466 1.19922 8.0002C1.19922 11.7538 4.24562 14.8002 7.99922 14.8002C11.7528 14.8002 14.7992 11.7538 14.7992 8.0002C14.7992 4.2466 11.7528 1.2002 7.99922 1.2002ZM7.99922 13.4402C4.99362 13.4402 2.55922 11.0058 2.55922 8.0002C2.55922 6.7422 2.98762 5.5862 3.70842 4.6682L11.3312 12.291C10.4132 13.0118 9.25722 13.4402 7.99922 13.4402ZM12.29 11.3322L4.66722 3.7094C5.58522 2.9886 6.74122 2.5602 7.99922 2.5602C11.0048 2.5602 13.4392 4.9946 13.4392 8.0002C13.4392 9.25819 13.0108 10.4142 12.29 11.3322Z",
    fill: "#00093A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecline);
export default __webpack_public_path__ + "static/media/Decline.7e768ffac8406f18c04b7d4186673bd7.svg";
export { ForwardRef as ReactComponent };